import BrandLogo from "@/components/BrandLogo";
import Link from "next/link";

import ConstellationBackground from "@/components/ConstellationBackground";
import { useBrandStore } from "@/hooks/useBrandStore";
import SignUpBox from "./SignUpBox";

import { ArrowLeft, LogIn } from "lucide-react";

export default function Signup() {
    const { brand } = useBrandStore();

    return (
        <div className="fixed inset-0 isolate overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-[#3f7d24] to-[#0d9488]" />
            <ConstellationBackground />

            <div className="relative z-10 flex items-center justify-between gap-3 px-4 py-4 sm:px-8">
                <Link
                    href="/"
                    className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white ring-1 ring-white/30 backdrop-blur-sm transition-colors hover:bg-white/25"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Voltar para o site
                </Link>

                <Link
                    href="/signin"
                    className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white ring-1 ring-white/30 backdrop-blur-sm transition-colors hover:bg-white/25"
                >
                    <LogIn className="h-4 w-4" />
                    Entrar
                </Link>
            </div>

            <main className="relative z-10 flex min-h-[calc(100vh-4rem)] items-center justify-center overflow-y-auto px-4 py-6">
                <div className="w-full max-w-md">
                    <div className="relative">
                        <div className="absolute -inset-px rounded-2xl bg-gradient-to-br from-[#3f7d24]/50 to-[#0d9488]/50 blur-md" />

                        <div className="relative rounded-2xl border border-white/40 bg-white/95 p-8 shadow-[0_20px_60px_-15px_rgba(15,118,110,0.45)] backdrop-blur-xl">
                            <div className="text-center">
                                <BrandLogo
                                    width={200}
                                    height={80}
                                    quality={100}
                                    unoptimized
                                    priority
                                    className="mx-auto mb-6 h-auto max-h-16 w-auto"
                                    wordmarkClassName="mb-6"
                                />
                            </div>

                            <SignUpBox source="default" />
                        </div>
                    </div>

                    <p className="mt-6 text-center text-xs text-white/80">
                        © {new Date().getFullYear()} {brand?.name ?? "Terraflow"} · Calculadora de
                        solo
                    </p>
                </div>
            </main>
        </div>
    );
}
